"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateVideoRules = void 0;
const constants_1 = require("../../payloads/constants");
const validateVideoRules = (rules) => {
    if (rules.access.type === constants_1.VIDEO_NOTIFICATION_ACCESS_TYPE.PUSH_CHAT &&
        (!rules.access.data.chatId || rules.access.data.chatId === '')) {
        throw new Error('Invalid rules object recieved. For access as Push Chat, chatId is required!');
    }
};
exports.validateVideoRules = validateVideoRules;
//# sourceMappingURL=validateVideoRules.js.map